import request from '@/util/request';
import util from "@/util/util";
class face {
  /**获取个人信息 */
  getpeoson(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.queryAccountInfo",
          data: {
            account_id: util.getCookie("account_id")
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**更新个人信息 */
  updatepeoson(self,value) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.updateAccountSetting",
          data: {
            account_id: util.getCookie("account_id"),
            company:value,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  /**更新密码 */
  updatePsd(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.setPassword",
          data: {
            account_id: util.getCookie("account_id"),
            password: self.ruleForm.pass,
            account_type:'user'
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
//   获取订单详情
  getbillNum(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.mail.queryMailAuthInfo",
          data: {
            account_id: util.getCookie("account_id")
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              if(res.body.code != 7006){
                self.$message.error(res.body.message || res.body.remark);
              }                  
            }
          }
        });
    });
  }
  //面单授权分配记录查询
  getauthorizRecords(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.mail.authoriz.records",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  //地址停发查询查询
  stopAreaSearch(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.address.queryIsReach",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
}
export default new face()